var map = {
	"./": 467,
	"./development": 1398,
	"./development.js": 1398,
	"./index": 467,
	"./index.js": 467,
	"./preprod": 1399,
	"./preprod.js": 1399,
	"./production": 1379,
	"./production.js": 1379,
	"./staging": 1400,
	"./staging.js": 1400
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3410;